export function addIndefiniteArticleToWord(word: string): string {
  const vowels = ["a", "e", "i", "o", "u"];
  const firstLetter = word[0].toLowerCase();
  const article = vowels.includes(firstLetter) ? "an" : "a";
  return `${article} ${word}`;
}
